import React from 'react'
// react component for creating dynamic tables
import ReactTable from 'react-table'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment'
import DeleteForever from '@material-ui/icons/DeleteForever'
import ZoomIn from '@material-ui/icons/ZoomIn'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import Button from 'components/CustomButtons/Button.jsx'

// general api
import { deleteRecord } from '../../services/generalServiceAPI'

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  updateProfileButton: {
    float: 'right'
  }
}

class DepartmentAllTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: []
    }
  }

  componentDidMount() {
    //apolloClient.query({ query: getDepartments }).then(response => this.setState({ data: response.data.departments }))
  }
  // This component gets data from props not state since there is no in-place editing allowed
  // The way to retrive data in the above method- didMount seems more neat than 'render function binding', but will keep using the binding way
  // since that's what they recommand and seems the error handling is more standard
  render() {
    const { classes, showEditProfile, departments } = this.props

    let displayData = []
    displayData = departments.map((c, k) => {
      return {
        ...c,
        actions: (
          <div>
            <Button
              justIcon
              round
              simple
              onClick={e => {
                let {
                  id,
                  name,
                  company: { id: companyId, name: companyName },
                  description
                } = c

                showEditProfile({
                  id,
                  name,
                  companyId,
                  companyName,
                  description
                })
              }}
              color="primary"
            >
              <ZoomIn className={classes.icon} />
            </Button>
            <Button
              justIcon
              round
              simple
              onClick={async () => {
                await deleteRecord({
                  tableName: 'departments',
                  id: c.id,
                  refetch: this.props.refetch
                })
                if (this.props.hideEditProfile) this.props.hideEditProfile()
              }}
              color="danger"
            >
              <DeleteForever className={classes.icon} />
            </Button>
          </div>
        )
      }
    })
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Departments </h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={displayData}
                filterable
                //overflow="hidden"
                columns={[
                  {
                    Header: 'Department Name',
                    accessor: 'name',
                    width: 250,
                    filterable: false
                  },
                  {
                    Header: 'Company',
                    id: 'company',
                    accessor: d => (d.company ? d.company.name : ''),
                    width: 250,
                    filterable: false
                  },
                  {
                    Header: 'Details',
                    accessor: 'description',
                    width: 500,
                    filterable: false
                  },
                  {
                    Header: 'Actions',
                    accessor: 'actions',
                    width: 100,
                    filterable: false,
                    style: {
                      align: 'center'
                    }
                  },
                  {
                    //fix alignment bug
                    width: 0,
                    filterable: false
                  }
                ]}
                // getTrProps={(state, rowInfo) => {
                //   return {
                //     onClick: e => {
                //       if (showEditProfile) {
                //         let {
                //           id,
                //           name,
                //           company: { id: companyId },
                //           description
                //         } = rowInfo.original

                //         showEditProfile({ id, name, companyId, description })
                //       }
                //     }
                //   }
                // }}
                defaultPageSize={5}
                //minRow={3}
                //headClassname=""
                showPaginationTop={false}
                showPaginationBottom={displayData.length > 5} //={true} //can be ignored
                className="-striped -highlight"
              />
              <Button
                color="rose"
                className={classes.updateProfileButton}
                onClick={() => {
                  showEditProfile({
                    id: '',
                    name: '',
                    companyId: '',
                    description: ''
                  })
                }}
              >
                Create new department
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }
}

export default withStyles(styles)(DepartmentAllTable)
